<template>
<div class="menu-item-r" style="padding-bottom: 30px;" v-loading="loading">
  <div class="chat-page-view">
    <div class="v-nav-wrap">
      <div class="op-select-view" v-if="false">
        <el-badge :is-dot="newMessageComing" class="coming">
          <el-button
            :class="{ 'el-button--primary': routeName === 'chat', 'el-button--primary-empty': routeName !== 'chat' }"
            type="primary"
            size="small"
            @click="changeFn('chat')"
            >{{ $t('notification') }}</el-button
          >
        </el-badge>
        <el-badge :is-dot="newMailComing" class="coming">
          <el-button
            :class="{ 'el-button--primary': routeName === 'mail', 'el-button--primary-empty': routeName !== 'mail' }"
            type="primary"
            size="small"
            @click="changeFn('mail')"
            >{{ $t('messageMail') }}</el-button>
        </el-badge>
      </div>
    </div>
    <div class="tc" style="width: 900px;">
      {{ $t('common.noData') }}
            <!-- <v-chat-width-employee-tim :name="'chat'" v-if="isTIM && flag" /> -->
          <!-- <div style="width:280px;">
            <v-conversation-list class="chat-container-left" v-if="true" />
          </div>
          <div style="width:620px">
            <v-current-conversation  :isClose="'false'" />
          </div> -->
      <!-- <div class="chat-user-list" v-loading="!$store.state.fetchImMsgStatus">
        <div
          class="user-card flex-center"
          :class="{ active: item.easemobAccount === receivingUser }"
          v-for="item in userList"
          :key="item.chatId"
          @click="setReceiver(item)"
        >
          <img class="item-avatar" :src="item.avatar || defImage('actor')" />
          <div class="item-info">
            <div class="item-name ellipsis">
              {{ item.name }}
              <span class="unreadNum" v-if="getUnreadNum(item) > 0">{{ getUnreadNum(item) }}</span>
            </div>
            <div class="last-msg" v-html="getLastMsg(item)"></div>
          </div>
        </div>
      </div> -->
      <!-- <div class="chat-dialog">
        <div class="dialog-mask" v-if="userList.length === 0 || !onLine"></div>
        <div class="title">
          <img class="chat-title__avatar" @click="showCard($store.state.receiver)" :src="$store.state.receiver.avatar || defImage('actor')" />
          <span class="chat-title__name">{{ $store.state.receiver.name }}</span>
          <span class="chat-title__position">{{ $store.state.receiver.position }}</span>
          <div v-if="imInfoCard" class="imInfoCard">
            <p class="text-right"><i @click="closeCard" class="el-icon-close"></i></p>
            <img  class="chat-title__avatar1" :src="imInfo.headImage || defImage('actor')" />
            <p class="font-size-16 p1 word-Wrap">{{ imInfo.name}}</p>
            <p class="font-size-14 p1 word-Wrap">{{ imInfo.post}}</p>
            <p class="font-size-12 p2 word-Wrap">{{ imInfo.corporateName}}</p>
            <p class="font-size-12 p2 word-Wrap">{{ imInfo.countryName}}</p>
          </div>
        </div>
        <ChatDialog />
      </div> -->
    </div>
  </div>
</div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
// import ConversationList from '@/components/Tim/ConversationList'
// import CurrentConversation from '@/components/Tim/CurrentConversation'
// import Calling from '@/components/Tim/Call.vue'
// import { ACTION } from '@/utils/funcTim.js'
// import ChatWithEmployeeTim from '@/components/Tim/ChatWithEmployee'
import { timMixin } from '@/mixins/timMixins.js'


export default {
    mixins: [timMixin],
    name: 'TimChatWithEmployee',
    components: {
        // 'v-conversation-list': ConversationList,
        // 'v-current-conversation': CurrentConversation,
        // 'v-chat-width-employee-tim': ChatWithEmployeeTim,
        // 'v-call': Calling
    },
    data() {
        return {
          routeName: 'chat',
          loading:true
        }
    },
    computed: {
        // ...mapState({
        //     chatDialogVisible: state => state.timStore.chatDialogVisible,
        //     userInfo: state => state.timStore.userInfo,
        //     currentConversation: state => state.timStore.currentConversation
        // }),
        ...mapState(['chatMsgList', 'receivingUser', 'userList', 'receiver', 'allChatData', 'onLine']),
        ...mapState({
          newMessageComing: state => state.timStore.newMessageComing,
          newMailComing: state => state.timStore.newMailComing,
        }),
        ...mapGetters(['language']),
        ...mapGetters([
            'isTIM',
            'toAccount',
            'chatDialogVisible',
            'userInfo',
            'currentConversation'
        ])
    },
     async mounted() {
        this.flag = true
        // if (this.$route.query.rName) {
        //     setTimeout(async()=>{
        //         await this.openChatDialog()
        //         this.loading = false
        //     }, 1500)
        // } else {
        //     await this.openChatDialog(true)
            this.loading = false
        // }

         

    },
    methods: {
      changeFn(value) {
          this.flag = false
          this.routeName = value
          this.$router.push('/' + value)
        }
    }
}
</script>

<style lang="stylus">
.coming{
  margin-right: 10px;
}
.chat-container {
    height: 608px;
    position: relative;
    background #fff;
    box-shadow: 0px 2px 6px 0px $box-shadow2;
}
.chat-container-left{
  border-right:1px solid $box-shadow2
}
.header{
  
}
</style>

